import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M10.8 16.042a6.042 6.042 0 1 0 0-12.084 6.042 6.042 0 0 0 0 12.084Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M10.8 12.708a2.708 2.708 0 1 0 0-5.416 2.708 2.708 0 0 0 0 5.416Zm-4.167 1.459 2.083-2.084m6.25 2.084-2.083-2.084M8.716 7.917 6.633 5.833m6.25 2.084 2.083-2.084" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);